import * as React from 'react';
import { IgcExpansionPanelComponent as Component } from 'igniteui-webcomponents';
import type { IgcExpansionPanelComponentEventMap } from 'igniteui-webcomponents';
import { type EventName, createComponent } from '../react-props.js';

/**
 * The Expansion Panel Component provides a way to display information in a toggleable way -
 * compact summary view containing title and description and expanded detail view containing
 * additional content to the summary header.
 * @slot  - renders the default content of the panel
 * @slot title - renders the title of the panel's header
 * @slot subtitle - renders the subtitle of the panel's header
 * @slot indicator - renders the expand/collapsed indicator
 * @slot indicator-expanded - renders the expanded state of the indicator
 * @fires igcOpening - Emitted before opening the expansion panel.
 * @fires igcOpened - Emitted after the expansion panel is opened.
 * @fires igcClosing - Emitted before closing the expansion panel.
 * @fires igcClosed - Emitted after the expansion panel is closed.
 * @csspart header - The container of the expansion indicator, title and subtitle.
 * @csspart title -  The title container.
 * @csspart subtitle - The subtitle container.
 * @csspart indicator - The indicator container.
 * @csspart content - The expansion panel's content wrapper.
 * @class
 */
export const IgrExpansionPanel = /* @__PURE__ */ createComponent({
  tagName: 'igc-expansion-panel',
  displayName: 'IgrExpansionPanel',
  elementClass: Component,
  react: React,
  events: {
    onOpening: 'igcOpening' as EventName<
      IgcExpansionPanelComponentEventMap['igcOpening']
    >,
    onOpened: 'igcOpened' as EventName<
      IgcExpansionPanelComponentEventMap['igcOpened']
    >,
    onClosing: 'igcClosing' as EventName<
      IgcExpansionPanelComponentEventMap['igcClosing']
    >,
    onClosed: 'igcClosed' as EventName<
      IgcExpansionPanelComponentEventMap['igcClosed']
    >,
  },
});

export type IgrExpansionPanel = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrExpansionPanelModule = Component;
